import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useTicketingPolicies } from 'modules/ticketing/hooks/useTicketingPolicies'
import { trackGoToTicketingSettings } from 'modules/ticketing/lib/tracking'

const RootPage = () => {
  const { loading, canViewSettings } = useTicketingPolicies()

  useEffect(() => {
    trackGoToTicketingSettings()
  }, [])

  if (loading) return <Loading />
  if (!canViewSettings) return <NotFound />

  return <Outlet />
}

export default RootPage
